module.exports = __webpack_public_path__ + "static/thumbnail_orejen_preview_1024.5981b127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/sections/signupPage/entrepreneurs/images/thumbnail_orejen_preview_1024.jpg
// module id = 1703
// module chunks = 168707334958949